// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"f2068a7e","977":"5b5d0bf2"}[chunkId] + ".chunk.js";
};